// reducers/LocationSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  locations: [],
  selectedLocationId: null,
  selectedLocationName: "",
  currentStep: 1, // 1 for the location, 2 for the service, and 3 for the booking details
  services: [],
  selectedServiceId: null,
  selectedServiceName: "",
  error: "",
  formSubmitted: false,
  formError: null,
};

const locationSlice = createSlice({
  name: "locations",
  initialState,
  reducers: {
    fetchLocations: (state) => {
      state.loading = true;
    },
    fetchLocationsSuccess: (state, action) => {
      state.loading = false;
      state.locations = action.payload;
      state.error = "";
    },
    fetchLocationsFailure: (state, action) => {
      state.loading = false;
      state.locations = [];
      state.error = action.payload;
    },
    setSelectedLocationId: (state, action) => {
      state.selectedLocationId = action.payload;
      const selectedLocation = state.locations.find(location => location.id === action.payload);
      state.selectedLocationName = selectedLocation ? selectedLocation.name : '';
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    fetchServices: (state) => {
      state.loading = true;
    },
    fetchServicesSuccess: (state, action) => {
      state.loading = false;
      state.services = action.payload;
      state.error = "";
    },
    fetchServicesFailure: (state, action) => {
      state.loading = false;
      state.services = [];
      state.error = action.payload;
    },
    setSelectedServiceId: (state, action) => {
      state.selectedServiceId = action.payload;
      const selectedService = state.services.find(service => service.id === action.payload);
      state.selectedServiceName = selectedService ? selectedService.name : '';
    },
    submitForm: (state) => {
      state.loading = true;
    },
    submitFormSuccess: (state) => {
      state.loading = false;
      state.formSubmitted = true;
      state.formError = null;
    },
    submitFormFailure: (state, action) => {
      state.loading = false;
      state.formSubmitted = false;
      state.formError = action.payload;
    },
    resetState: () => initialState // Reset action
  },
});

export const {
  fetchLocations,
  fetchLocationsSuccess,
  fetchLocationsFailure,
  setSelectedLocationId,
  setCurrentStep,
  fetchServices,
  fetchServicesSuccess,
  fetchServicesFailure,
  setSelectedServiceId,
  submitForm,
  submitFormSuccess,
  submitFormFailure,
  resetState,
} = locationSlice.actions;

export default locationSlice.reducer;
